import { VAN_VIN_REGEX } from '../constants/van'

function determineIsVinValid(vin: string): boolean {
  return VAN_VIN_REGEX.test(vin)
}

export default determineIsVinValid
